export default "__VITE_ASSET__86959131__"